import { Controller } from "@hotwired/stimulus"

// Phase 2.6 Tier 3 — live preview for the RiskRule admin form.
// Posts to the rule's #preview action and renders matched-project
// count + sample current value back into the side tile. Mirrors the
// PortfolioAlertRule preview pattern; doesn't write any firings.
export default class extends Controller {
  static targets = ["previewResult"]
  static values = { previewUrl: String }

  preview() {
    if (!this.hasPreviewUrlValue || this.previewUrlValue === "") return
    if (!this.hasPreviewResultTarget) return

    this.previewResultTarget.innerHTML =
      '<span class="text-gray-500">Evaluating…</span>'

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.previewUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf || ""
      }
    })
      .then((r) => r.json())
      .then((payload) => {
        if (!payload.success) {
          this.previewResultTarget.innerHTML =
            '<span class="text-rose-700">Preview failed.</span>'
          return
        }
        const count = payload.matched_count || 0
        const sample = payload.current_value
        const sampleHtml = sample !== null && sample !== undefined
          ? `<div class="text-[11px] text-gray-500">Worst current value: <span class="font-medium text-gray-700">${sample}</span></div>`
          : ""
        this.previewResultTarget.innerHTML = `
          <div class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
            <div class="text-[13px] text-gray-800">
              Would fire on <span class="font-semibold">${count}</span> project${count === 1 ? "" : "s"} right now.
            </div>
            ${sampleHtml}
          </div>
        `
      })
      .catch(() => {
        this.previewResultTarget.innerHTML =
          '<span class="text-rose-700">Preview failed (network).</span>'
      })
  }
}
